import { createVoltraComponent } from './createVoltraComponent.js'
import type { LinearProgressViewProps } from './props/LinearProgressView.js'

export type { LinearProgressViewProps }
export const LinearProgressView = createVoltraComponent<LinearProgressViewProps>('LinearProgressView')
